import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
// 本地的文件夹
import zhLocale from './pack/zn'
import viLocale from './pack/vi'

// vant中的文件夹  需要的语言和本地的语言保持一致
import zhCN from 'vant/lib/locale/lang/zh-CN'
import viVN from 'vant/lib/locale/lang/vi-VN'
Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhCN,
    ...zhLocale
  },
  vi: {
    ...viVN,
    ...viLocale
  }
}
// localStorage获取当前语言类型(初次本地不存在'lang'字段存储，默认设置为'zh_CN')
const lang = 'vi'
// 初次加载的语言默认设置
Locale.use(lang, messages[lang])

export default new VueI18n({
  locale: lang, // set locale
  messages: messages // set locale messages
})
